<script>
    export let id;
    export let label;
    export let value;
    export let valido = true;
    export let mensajeDeError = "";
    export let icono = false;
    export let disabled = false;

    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();

    import axios from "../../axios-control";

    let touched = false;
    let enviando = false;

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const actualizaFoto = async e => {
      const imagen = await toBase64(e.target.files[0]);
      if (imagen.indexOf('data:image/jpeg') !== 0) {
        alert('La imagen debe tener formato jpg');
      } else {
        dispatch('change', imagen);
      }
    };
</script>

<style>
    .campo {
        border: 2px solid var(--bordes);
        border-radius: 3px 3px 0 0;
        display: flex;
    }

    .icono {
        flex: 0 0 auto;
        background: var(--bordes);
        display: flex;
        align-items: flex-start;
        justify-content: center;
        color: var(--negro);
        padding: .25rem;
    }

    label {
        display: block;
        margin-bottom: 0.5rem;
        width: 100%;
    }

    .form-control {
        padding: 0.5rem 0;
        width: 100%;
        margin: 0.25rem 0;
    }

    .invalid {
        border-color: var(--acentos);
    }

    .invalid .icono {
        background: var(--acentos);
    }

    .error-message {
        color: red;
        margin: 0.25rem 0;
    }

    .disabled input {
        opacity: .5;
    }

    img {
        margin-top: 1em;
        max-width: 100%;
        display: block;
    }
</style>

<div class="form-control">
    {#if label}
        <label for={id}>{label}</label>
    {/if}

    <div class="campo" class:invalid="{!valido && touched}" class:disabled>
        {#if icono}
            <div class="icono">
                <i class="material-icons">{icono}</i>
            </div>
        {/if}

        <input type="file" id={id} accept=".jpg,.jpeg" on:change={actualizaFoto} {disabled}/>
    </div>

    {#if mensajeDeError}
        <p class="error-message">{mensajeDeError}</p>
    {/if}

    {#if value}
        <img src={value} width="200" alt="">
    {/if}
</div>
